import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({ whatsappStyles: { margin: '7px' } });
export default styles;
